export default "__VITE_ASSET__VstM5yLH__"